/*
 *   File : text-area.js
 *   Author : https://evoqins.com
 *   Description : Text area component
 *   Integrations : NA
 *   Version : 1.0.0
 */
import React, { memo, useState } from "react";
import styles from "../../Style/Components/input.module.scss";

const CustomTextArea = (props) => {
  const [isInputFocused, setIsInputFocused] = useState(false);

  const _handleChange = (e) => {
    props.handleChange(e.target.value);
  };

  return (
    <div
      className={styles.e_textarea_wrap ? styles.e_textarea_wrap : "h-100px"}
    >
      {props.label && (
        <label
          className={
            props.labelStyle
              ? props.labelStyle
              : "e-text-black e-primary-font-poppins  e-font-weight-500  e-font-14 "
          }
        >
          {props.label}
          {props.require && <span className="text-danger">*</span>}
        </label>
      )}

      <div className="pt-2">
        <textarea
          id={props.id}
          value={props.value}
          style={{ resize: "none"}}
          autoFocus={props.autoFocus}
          className={`${props.className} ${
            props.error ? "e-border-1px-ruby" : ""
          } ${
            isInputFocused
              ? "e-border-input-focus"
              : `e-border-input ${props.borderStyle}`
          }  e-border-radius-8 e-bg-white e-font-14 e-text-raisin-black e-font-weight-400 e-primary-font shadow-none resize-none`}
          placeholder={props.placeholder}
          required={props.required}
          rows={props.rows ? props.rows : 6}
          readOnly={props.readOnly}
          cols={props.cols}
          onChange={_handleChange}
          onFocus={() => setIsInputFocused(true)}
          onBlur={() => setIsInputFocused(false)}
        />
        {props.error && (
          <p className="mb-0 e-font-12 text-danger e-primary-font-poppins  pt-1">
            {props.error}
          </p>
        )}
      </div>
    </div>
  );
};

CustomTextArea.defaultProps = {
  handleChange: () => {},
  className: "",
  error: "",
};

export default memo(CustomTextArea);
